// Client-side mirror of the server password policy. Only length is checked
// here; the server also rejects common, all-numeric and name/email-similar
// passwords, and its 400 response is the source of truth.
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_HINT =
  'At least 12 characters. Avoid common passwords and anything similar to your name or email.';

export function validatePasswordClient(password) {
  const value = typeof password === 'string' ? password : '';
  const problems = [];
  if (value.length < PASSWORD_MIN_LENGTH) {
    problems.push(`Password must be at least ${PASSWORD_MIN_LENGTH} characters long.`);
  }
  return problems;
}
